import { createSelector } from 'reselect'
import { selectKnownMailboxes } from './selectKnownMailboxes'
import { CHANNEL_STATE } from '../constants'

export const selectRealMailboxes = createSelector(
  selectKnownMailboxes,
  knownMailboxes =>
    knownMailboxes.filter(mailbox => mailbox.state !== CHANNEL_STATE.DEMO)
)
